import { notifications } from '@mantine/notifications';
import {
  CreateOrderItem,
  OrderingInitialState,
  RemoveOrDecreaseMenuItemByTempIdAction,
} from '@reducers/ordering/types';
import messages from '@shared/constants/messages';
import { safeString } from '@utils/stringUtil';

const removeEditItems = (state: OrderingInitialState, id: string): OrderingInitialState => {
  const menuItem = state?.orderState.menus?.find((x) => x.tempId === id);

  if (menuItem) {
    if (menuItem?.count && menuItem?.count > 1) {
      return {
        ...state,
        orderState: {
          ...state.orderState,
          menus:
            state?.orderState.menus?.map((item) => {
              if (item.tempId === id) {
                return {
                  ...item,
                  count: (item.count || 0) - 1,
                  orderItemToppings: item?.orderItemToppings?.map((x) => ({
                    ...x,
                    count: (item.count || 0) - 1,
                  })),
                  toppings: item?.orderItemToppings?.map((x) => ({
                    ...x,
                    count: (item.count || 0) - 1,
                  })),
                };
              }
              return item;
            }) || [],
        },
      };
    }

    const orderOrderItems = state?.orderState.menus
      ?.filter((x) => x.tempId !== id)
      .reduce((acc, cur) => acc + (cur?.count || 0), 0);
    if (orderOrderItems === 0) {
      notifications.show({
        message: messages.NOT_ALLOW_REMOVE_ALL_ITEMS,
        color: 'red',
      });
      return state;
    }

    return {
      ...state,
      orderState: {
        ...state.orderState,
        menus: state?.orderState.menus?.filter((x) => x.tempId !== id),
        removedItems: [
          ...(state?.orderState.removedItems || []),
          ...(state?.orderState.order?.orderItems
            ?.filter((x) => x.id === id)
            .map(
              (item) =>
                ({
                  count: item?.count,
                  discount: item?.discount || 0,
                  menuItemId: item?.menuItemId || '',
                  title: item?.title || '',
                  price: item?.price || 0,
                  packagingCost: item?.packagingCost || 0,
                  servePackagingCost: item?.packagingCost || 0,
                  tempId: safeString(item?.id),
                  orderItemToppings: item?.toppings?.map((x) => ({
                    count: item?.count,
                    price: x.price,
                    title: x.title,
                    toppingId: x.id,
                  })),
                }) as CreateOrderItem
            ) || []),
        ],
      },
    };
  }
  return { ...state };
};

export const removeOrDecreaseMenuItemByTempId = (
  state: OrderingInitialState,
  action: RemoveOrDecreaseMenuItemByTempIdAction
): OrderingInitialState => {
  const { tempId } = action.payload;
  if (state?.orderState.isEdited) {
    return removeEditItems(state, tempId);
  }
  const menuItem = state.orderState.menus.find((x) => x.tempId === tempId);
  if (menuItem) {
    if (menuItem?.count && menuItem?.count > 1) {
      return {
        ...state,
        orderState: {
          ...state.orderState,
          menus: state.orderState.menus.map((item) => {
            if (item.tempId === tempId) {
              return {
                ...item,
                count: (item.count || 0) - 1,
                orderItemToppings: item?.orderItemToppings?.map((x) => ({
                  ...x,
                  count: (item.count || 0) - 1,
                })),
              };
            }
            return item;
          }),
        },
      };
    }
    return {
      ...state,
      orderState: {
        ...state.orderState,
        menus: state.orderState.menus.filter((x) => x.tempId !== tempId),
      },
    };
  }
  return state;
};
